export const CONSTANTS = {
  LANGUAGE_STORAGE_KEY: 'lang',
  LANGUAGE_DEFAULT: 'en',
  THEME_STORAGE_KEY: 'theme',
  THEME_DEFAULT: 'en',
  FORMAT_DATE: 'DD-MM-YYYY',
  NEWS_IMG_PATH: '/media/news/',
} as const;

export const getConstants = () => CONSTANTS;
